import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    //所有的数据都放在state中
    state:{
        uploadurl:'/api/files/upload', //上传
        user:'',
    },
    //操作数据，唯一的通道是mutations
    mutations:{
        setuser(state,val){
            state.user = val
        },
    },
    //actions,可以来做异步操作，然后提交给mutations，而后再对state(数据)进行操作
    actions:{
        setuser(context,val){
            context.commit('setuser',val);
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js